import React from "react";

const SaranaBelajarRobotikObstacle: React.FC = () => {
    return (
        <div className="text-justify py-4">
            <h2 className="text-lg font-semibold mb-3">
                🤖 Obstacle Avoidance Driving Robot Game sebagai Media Pembelajaran Robotik
            </h2>

            <p className="mb-4">
                Perkembangan teknologi robotik mendorong metode pembelajaran yang semakin mengutamakan praktik langsung dan pemahaman sistem secara menyeluruh. Berbagai program edukasi robotik kini dirancang untuk membantu peserta memahami konsep robot bergerak, navigasi, dan sistem otomatis sejak dini.
            </p>

            <p className="mb-4">
                Pendekatan ini banyak dikembangkan oleh platform edukasi seperti{' '}
                <a
                    href="https://indobot.co.id/"
                    className="text-blue-600 underline font-semibold hover:text-blue-800"
                    target="_blank"
                    rel="noopener noreferrer"
                >
                    Indobot Academy
                </a>
                ,{' '}
                <a
                    href="https://www.robotics.co.id/"
                    className="text-blue-600 underline font-semibold hover:text-blue-800"
                    target="_blank"
                    rel="noopener noreferrer"
                >
                    Robotics Education Centre
                </a>
                , dan{' '}
                <a
                    href="https://sekolahrobot.co.id/"
                    className="text-blue-600 underline font-semibold hover:text-blue-800"
                    target="_blank"
                    rel="noopener noreferrer"
                >
                    Sekolah Robot Indonesia
                </a>
                . Dalam konteks tersebut, Obstacle Avoidance Driving Robot Game menjadi salah satu media pembelajaran yang efektif untuk mengenalkan dasar navigasi, pengendalian sistem, dan interaksi robot dengan lingkungan sekitarnya.
            </p>

            <h3 className="text-md font-semibold mb-2">
                🌍 Robot Otonom dalam Kompetisi Global
            </h3>

            <p className="mb-4">
                Penerapan pembelajaran robot bergerak juga terlihat dalam berbagai ajang robotik nasional dan internasional. Salah satunya adalah <a href="https://wro-association.org/" className="text-blue-600 underline font-semibold hover:text-blue-800" target="_blank" rel="noopener noreferrer">World Robot Olympiad</a> yang secara konsisten mengangkat tantangan robot otonom dan navigasi sebagai bagian dari kompetisi global bagi pelajar.
            </p>

            <p className="mb-4">
                Kompetisi ini menekankan kemampuan robot dalam membaca lingkungan, menghindari rintangan, serta mengambil keputusan berbasis sensor sebagai bagian dari sistem otomatis yang cerdas.
            </p>

            <h3 className="text-md font-semibold mb-2">
                ⚙️ Proses Perancangan dan Pengujian Robot
            </h3>

            <p className="mb-4">
                Dalam proses perancangannya, peserta mempelajari penggunaan sensor jarak, sistem penggerak, serta logika kontrol dasar yang mengatur pergerakan robot. Setiap komponen memiliki peran penting agar robot dapat bergerak stabil dan mampu menghindari rintangan secara mandiri.
            </p>

            <p className="mb-4">
                Tahapan perakitan, pengujian, hingga penyempurnaan sistem memberikan pengalaman belajar yang membantu peserta memahami keterkaitan antara perangkat keras dan perangkat lunak dalam sistem robotik.
            </p>

            <h3 className="text-md font-semibold mb-2">
                🚀 Dukungan Talenta Digital Sejak Dini
            </h3>

            <p className="mb-4">
                Pendekatan pembelajaran seperti ini sejalan dengan meningkatnya minat terhadap ekskul robot di sekolah yang kerap disorot dalam wacana pengembangan talenta digital generasi muda, termasuk pentingnya penguasaan teknologi dan inovasi sejak dini.
            </p>

            <p className="mb-4">
                Dukungan pembelajaran robotik dan STEM juga diperkuat oleh berbagai platform edukasi, salah satunya <strong>AEDU (Accelist Edukasi)</strong>. Informasi lengkap mengenai AEDU dapat diakses melalui{' '}
                <a
                    href="https://edukasi.accelist.com/"
                    className="text-blue-600 underline font-semibold hover:text-blue-800"
                    target="_blank"
                    rel="noopener noreferrer"
                >
                    website AEDU
                </a>.
            </p>

            <p className="text-gray-700">
                Melalui program yang diselenggarakan oleh <strong>IIT</strong>, Obstacle Avoidance Driving Robot Game menjadi sarana pembelajaran yang terstruktur dan aplikatif. Peserta tidak hanya memperoleh pengetahuan teknis robotik, tetapi juga mengembangkan ketelitian, kemampuan analisis, dan pemahaman sistem yang dibutuhkan dalam bidang teknologi dan rekayasa.
            </p>

            <p className="mt-4 font-semibold">
                👉 Cek informasi{' '}
                <a
                    href="/iit-program?program=ObstacleDriving"
                    className="text-blue-600 underline font-semibold hover:text-blue-800"
                    target="_blank"
                >
                    Obstacle Avoidance Driving Robot Game
                </a>{' '}
                lebih lanjut
            </p>
        </div>
    );
};

export default SaranaBelajarRobotikObstacle;
